export function assertNever(value: never): never {
  throw new Error(
    `Did not expect assertNever to be called. value: ${JSON.stringify(value)}`,
  )
}
